function tidyAtRule(value) {
  return value
    .replace(/\s+/g, ' ')
    .replace(/url\(\s+/g, 'url(')
    .replace(/\s+\)/g, ')')
    .trim();
}

module.exports = tidyAtRule;



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/lib/optimizer/level-1/tidy-at-rule.js
// module id = 2411
// module chunks = 9